module.exports = __webpack_public_path__ + "img/6x42_.prt.c08e9630.jpg";